import { createGlobalStyle } from 'styled-components/macro';

import staticData from '../../static_data/all';

import _avertaWoff from '../../assets/font/averta.woff';
import _avertaWoff2 from '../../assets/font/averta.woff2';
import _avertaBoldWoff from '../../assets/font/averta-bold.woff';
import _avertaBoldWoff2 from '../../assets/font/averta-bold.woff2';
import _avertaLightWoff from '../../assets/font/averta-light.woff';
import _avertaLightWoff2 from '../../assets/font/averta-light.woff2';
import _avertaSemiBoldWoff from '../../assets/font/averta-semibold.woff';
import _avertaSemiBoldWoff2 from '../../assets/font/averta-semibold.woff2';

let avertaWoff = _avertaWoff;
let avertaWoff2 = _avertaWoff2;
let avertaBoldWoff = _avertaBoldWoff;
let avertaBoldWoff2 = _avertaBoldWoff2;
let avertaLightWoff = _avertaLightWoff;
let avertaLightWoff2 = _avertaLightWoff2;
let avertaSemiBoldWoff = _avertaSemiBoldWoff;
let avertaSemiBoldWoff2 = _avertaSemiBoldWoff2;

if (staticData.useStatic) {
    avertaWoff = 'https://s3.amazonaws.com/actionbutton.fonts/averta.woff';
    avertaWoff2 = 'https://s3.amazonaws.com/actionbutton.fonts/averta.woff2';
    avertaBoldWoff = 'https://s3.amazonaws.com/actionbutton.fonts/averta-bold.woff';
    avertaBoldWoff2 = 'https://s3.amazonaws.com/actionbutton.fonts/averta-bold.woff2';
    avertaLightWoff = 'https://s3.amazonaws.com/actionbutton.fonts/averta-light.woff';
    avertaLightWoff2 = 'https://s3.amazonaws.com/actionbutton.fonts/averta-light.woff2';
    avertaSemiBoldWoff =
        'https://s3.amazonaws.com/actionbutton.fonts/averta-semibold.woff';
    avertaSemiBoldWoff2 =
        'https://s3.amazonaws.com/actionbutton.fonts/averta-semibold.woff2';

    // static doesn't use the public/index.html, and hence doesn't load Lato
    if (typeof document !== 'undefined') {
        var link = document.createElement('link');
        link.href = 'https://fonts.googleapis.com/css?family=Lato&subset=latin,latin-ext';
        link.rel = 'stylesheet';
        link.type = 'text/css';
        document.body.appendChild(link);
    }
}

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Averta';
    font-display: auto;
    src:
      url(${avertaLightWoff2}) format('woff2'),
      url(${avertaLightWoff}) format('woff');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Averta';
    font-display: auto;
    src:
      url(${avertaWoff2}) format('woff2'),
      url(${avertaWoff}) format('woff');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Averta';
    font-display: auto;
    src:
      url(${avertaSemiBoldWoff2}) format('woff2'),
      url(${avertaSemiBoldWoff}) format('woff');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'Averta';
    font-display: auto;
    src:
      url(${avertaBoldWoff2}) format('woff2'),
      url(${avertaBoldWoff}) format('woff');
    font-weight: 700;
    font-style: normal;
  }

  #google_autocomplete__label {
    &.error {
      /* color: #ff245e; */
    }
  }

  #google_autocomplete {
    width: 100% !important;
    height: 36px;
    font-family: Averta;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 1px;
    border-radius: 2px;
    border: solid 1px #f1f1ee;
    line-height: 20px;
    padding: 8px;
    color: #000;

    @media (max-width: 480px) {
      font-size: 16px;
    }

    &.autocompleteError {
      border: solid 1px #ff245e;
      color: #ff245e;
    }

    &:active, &:focus {
      outline: none;
      border: solid 1px #979191;
    }
  }

  .pac-container {
    font-family: Averta;
    letter-spacing: .5px;
    font-size: 14px;

    .pac-matched {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  h3 {
    font-weight: 400;
    margin: 0.5em 0;
  }

  p {
    margin: 0 0 1em;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;

    -webkit-font-smoothing: antialiased;
    font-smoothing: antialiased;
    font-smooth: always;

    min-height: 0;
    min-width: 0;
  }

  body {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
  }

  #root {
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;

    & > div {
      flex: 1;
    }
  }

  .body-msn-override {
      flex: 1;
      margin: 1em 1em 0;
      display: flex;
      flex-direction: column;
  }

  input:-webkit-autofill, input:-webkit-autofill:focus {
    -webkit-box-shadow:0 0 0 50px white inset;
  }
`;

export const IEStyle = createGlobalStyle`
  body{
    display: block;
  }

  #root{
    margin: auto;
    max-width: 620px;
    overflow: hidden !important;
  }

  input[type="email"], input[type="text"]{
    display: block !important;
    opacity: 1 !important;
  }

  input[type=range]::-ms-tooltip{
    display: none;
  }

  select::-ms-expand{
    display: none !important;
  }

  .ie-two-group{
    max-width: 14.75rem;
  }

  .ie-auto-scaling-button-set{
    width: 0;
  }

  .ie-payment-button-container-parent{
    padding-left: 4rem !important;
    padding-right: 4rem !important;
    display: inline-block !important;
  }

  .ie-payment-button-container{
    display: flex !important;
  }

  .ie-payment-icon{
    height: 18px !important;
  }

  .ie-auto-pay{
    display: none !important;
  }

  .ie-bounce-get-updates-row{
    padding-bottom: 3rem !important;
  }

  .ie-slider-before{
    position: absolute;
    top: -22px;
    margin-bottom: -40px !important;
    opacity: 0 !important;
  }
  .ie-slider-after {
    top: -23px !important;
    position: absolute;
    opacity: 0 !important;
  }

  .ie-right-arrow-before{
    height: 18px !important;
    top: 7px !important;
  }
  .ie-left-arrow-before, .ie-left-arrow-before:hover{
    top: 0px !important;
    left: 5px !important;
    height:32px !important;
  }

  .ie-right-arrow-after{
    height: 18px !important;
    top: -6px !important;
  }
  .ie-left-arrow-after, .ie-left-arrow-after:hover{
    top: -5px !important;
    height: 16px !important;
  }

  .ie-sentiment-graph-details{
    margin-bottom: 50px !important;
  }

  .ie-small-arrows{
    top: -14px !important
  }
  .ie-large-arrows{
    top: -8px !important;
  }

  .ie-slider-thumb-before{
    margin-top: -16px !important;
  }
  .ie-slider-thumb-after{
    top: -10px !important;
  }

  .ie-multi-image-block-fix{
    margin-top: 4rem !important;
  }

  .ie-object-fit-cover-polyfill{
    object-fit: cover;
    object-position: center;
    font-family: 'object-fit: cover; object-position: center;';
  }

  .ie-object-fit-contain-polyfill{
    object-fit: contain;
    font-family: 'object-fit: contain;';
  }

  .ie-find-rep-form{
    height: 7rem;
    width: 25rem;
  }

  .ie-find-rep-button-container{
    margin-left: 3rem;
  }

  .ie-rep-stance-container{
    -webkit-align-items: flex-end !important;
    justify-content: space-between !important;
    padding: 0 5rem 0 !important;
  }

  .ie-rep-stance-button-container{
    & button{
      min-height: 32px !important;
    }
  }

  .ie-poll-station-address-finder-container{
    -ms-overflow-style: none;
  }

  .ie-legal-info{
    max-width: 10rem;
  }

  .ie-volunteer-form-container{
    height: 13rem !important;
    overflow-y: hidden !important;
  }

  .ie-share-drawer-content{
    transform: translateY(-83px) !important;
  }

  .ie-small-submit-button-loading-spinner{
    margin-right: 2rem !important;
  }

  .ie-hide-scrollbar{
    overflow-y: hidden !important;
  }
  .ie-bounce-modal-buttons{
    max-width: 11.9rem !important;
  }

  .ie-slick-slider-width{
    width: 100% !important;
  }

  .ie-donation-description{
    padding-bottom: 2.5rem !important;
  }

  .ie-action-choice-details-container{
    max-height: 4rem !important;
  }

  .ie-single-action-details-description{
    margin-bottom: 20px !important;
  }
`;
